<template>
  <div class="main-companys primary-bg">
    <div class="container">
      <ul class="nav nav-pills con-nav justify-content-center">
        <li class="nav-item">
          <a
            class="nav-link flex-column"
            :class="{ active: activeTab === 'all' }"
            @click="changeTab('all')"
          >
            <div class="mb-2 con-img-tab">
              <img
                :src="
                  activeTab === 'all'
                    ? require('../../assets/img/icon/companies.svg')
                    : require('../../assets/img/icon/companies-black.svg')
                "
              />
            </div>
            <div>كل المؤسسات</div>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link flex-column"
            :class="{ active: activeTab === 'training' }"
            @click="changeTab('training')"
          >
            <div class="mb-2 con-img-tab">
              <img
                :src="
                  activeTab === 'training'
                    ? require('../../assets/img/icon/emps.svg')
                    : require('../../assets/img/icon/emps-black.svg')
                "
              />
            </div>
            <div>شركات تدريب</div>
          </a>
        </li>
      </ul>
      <div class="row text-center">
        <div class="row con-sec-wrapper">
          <div class="row" v-if="activeTab === 'all'" id="section-all">
            <Companies
              :CompaniesList="companysData"
              :columns="companiesColumns"
              @search="updateSearch"

            />
          </div>
          <div class="row m-0" v-if="activeTab === 'training'" id="section-training">
            <TrainingCompanies
              :trainingCompaniesList="companysTrainingsData"
              :columns="trainingColumns"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

   <script>
import TrainingCompanies from "./TrainingCompanies.vue";
import Companies from "./Companies.vue";
import SmoothScroll from "smooth-scroll";

export default {
  name: "companysArea",
  components: { TrainingCompanies, Companies },
  props: {
    companies: { type: Array, default: () => [] },
  },
  data() {
    return {
      activeTab: "all",
      itemsPerPage: 2,
      currentPage: 1,
      totalPages: 5,
      companiesColumns: [
        { field: "image", title: "شعار المؤسسة " },
        { field: "name", title: " اسم المؤسسة" },
        { field: "established_at", title: "تاريخ التأسيس " },
        { field: "no_of_employees", title: " عدد الموظفين " },
        {
          field: "no_of_certified_employees",
          title: "عدد الموظفين المعتمدين ",
        },
        { field: "category", title: " نشاط المؤسسة  " },
        { field: "commercial_register_num", title: " رقم السجل   " },
        { field: "actions", title: "عرض" },
      ],
      trainingColumns: [
        { field: "image", title: "شعار الشركة " },
        { field: "name", title: "شركة التدريب" },
        { field: "established_at", title: "تاريخ التأسيس " },
        { field: "certificates", title: " عدد المدربين" },
        { field: "actions", title: "عرض" },
      ],
    };
  },
  watch: {
    searchQuery: {
      handler: 'fetchEmployeesList',
      immediate: true,
    },
  },
  computed: {
    filteredCompanys() {
      if (this.companies.length !== 0) {
        return this.companies;
      }
      return this.filterData(this.activeTab);
    },
    companysData() {
      return this.$store.state.companies.companysData;
    },
    companysTrainingsData() {
      return this.$store.state.companies.companysTrainingsData;
    },
  },
  created() {
    this.$store.dispatch("companies/fetchCompanysData");
    this.$store.dispatch("companies/fetchCompanysTrainingsData");
  },
  methods: {
    filterData(tab) {
      if (tab === "all") {
        return this.companysData.companies;
      } else if (tab === "training") {
        return this.companysTrainingsData.training_companies;
      }
      return [];
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    async updateSearch(query) {
      // Update the search query and make the API call
      this.searchQuery = query;
      await this.$store.dispatch('companies/fetchCompanysData', this.searchQuery);

    },
    changeTab(tab) {
      this.activeTab = tab;
      this.$nextTick(() => {
      // Get the element associated with the active tab
      const element = document.getElementById(`section-${tab}`);

      // Check if the element exists before attempting to scroll
      if (element) {
        const scroll = new SmoothScroll();
        scroll.animateScroll(element);
      }
    });
    },
  },
};
</script>
